<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Lampiran</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="ID Registration"
                class="mb-0"
                horizontal
                placeholder="ID Agent"
                v-model.trim="agentData.agent_id"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInputFile label="Foto Tampak Dalam" horizontal custom />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Nama Pendaftar"
                class="mb-0"
                horizontal
                placeholder="Nama Pendaftar"
                v-model.trim="agentData.register_name"
              />
            </CCol>

            <CCol :col="6">
              <CInputFile label="Foto Tampak Jalan" horizontal custom />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInputFile class="mb-0" label="Foto KTP" horizontal custom />
            </CCol>

            <CCol :col="6">
              <CInputFile label="Foto NPWP" horizontal custom />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInputFile label="Foto Tampak Depan" horizontal custom />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="update"
                >SAVE</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

export default {
  name: "NewRegistrationEdit",

  data() {
    return {
      agentData: {},
      items: [],
      fields: [
        { key: "flag", label: "Action" },
        { key: "flag", label: "Status Pengajuan" },
        { key: "reason", label: "Reason" },
        { key: "created_by", label: "Created By" },
        { key: "created_at", label: "Created Date" },
      ],
      createAgentData: {},
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },
  methods: {
    getDataByID() {
      let accountID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/agent/${accountID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.agentData = response.data;
          //  this.agentData.created_at = moment(String(this.agentData.created_at)).format('MM/DD/YYYY hh:mm')
          this.items = [this.agentData];
        })
        .catch((e) => {
          console.log(e);
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/agent/new-registration" });
    },
    handleNote(event) {
      this.agentData.reason = event;
    },

    update() {
      let accountID = this.$route.params.id;
      this.agentData.flag = "FOLLOW UP";
      axios
        .put(`${this.domain}/v1/agent/${accountID}`, this.agentData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Agent Data Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/agent/new-registration` });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Some Data Is missing or invalid",
          });
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "./Agent.css";
</style>
